import React, {useEffect, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card } from '@material-ui/core';
import { Breadcrumb, BackdropCircular } from 'components';
import { getReferralRules, getStoreProductsApi, getStoreCategoriesApi, getStoreCustomerGroupsApi } from 'api';
import ReferralProgramList from './ReferralProgramsList';
import CreateReferralRule from './CreateReferralRule';


const ReferralProgram = () =>  {
  const dispatch = useDispatch();
  const [referralProgramMode, setReferralProgramMode] = useState(true);
  const { loadingReferralRules, referralRulesList } = useSelector((state) => state.referral_program);
  const {store_products: {catalogProducts}} = useSelector((state) => state.products);
  const {storeActiveCategoriesWithActiveNavLevel} = useSelector((state) => state.categories);
  const {loadingUpdateCmsPages} = useSelector((state) => state.cms_pages);

  useEffect(() => {
    getReferralRules({dispatch});
    getStoreCustomerGroupsApi({dispatch});
  }, []);

  useEffect(() => {
    getReferralRules({dispatch});
  }, [referralRulesList.length]);

  useEffect(() => {
    if (!catalogProducts.length) {
      getStoreProductsApi({dispatch});
    }

    if (!storeActiveCategoriesWithActiveNavLevel.length) {
      getStoreCategoriesApi({dispatch, checkStoreType: false});
    }
  }, []);

  return (
    <div className="flex-grow flex-column relative h-full scroll-y">
      <div>
        <Breadcrumb
          routeSegments={[
            { name: 'Settings', path: '/settings#go_live_requirements' },
            { name: 'Store Configurations', path: '/settings#store_configurations' },
            { name: 'Referral Program' }
          ]}
        />
      </div>
      <div className="m-10">
        {referralProgramMode ?
          <Card className="p-8">
            <ReferralProgramList
              setReferralProgramMode={setReferralProgramMode}
              products={catalogProducts}
              categories={storeActiveCategoriesWithActiveNavLevel}
            />
          </Card>
          :
          <Card className="p-8">
            <CreateReferralRule
              setReferralProgramMode={setReferralProgramMode}
              products={catalogProducts}
              categories={storeActiveCategoriesWithActiveNavLevel}
            />
          </Card>
        }
        <BackdropCircular loading={loadingReferralRules || loadingUpdateCmsPages} />
      </div>
    </div>
  );
};

export default ReferralProgram;
